module.exports = __webpack_public_path__ + "media/images/logo_hrbasepro-3e8b52d6.png";